export default "__VITE_ASSET__kkG$uSHt__"